import { RxMeetingsAPI, MeetingsAPI } from '@driftt/dapper'

export const fetchCalendarStatus = async () => {
  const response = await MeetingsAPI.get('/scheduling/settings/status')
  const data = await response.json()
  return data
}

export const connectDefaultCalendar = (calendarProvider, userId) => (
  MeetingsAPI.post(`/${calendarProvider}/calendar/${userId}/calendars/choose/primary`)
)

export const fetchGoogleCalendars = () => {
  return RxMeetingsAPI.get('/google/calendar/calendars')
    .checkStatus()
    .retryWithBackoff()
    .map(({ response }) => {
      return response
    })
}

export const updateGoogleCalendar = calendar => {
  return RxMeetingsAPI.post('/google/calendar/calendars/choose', calendar).checkStatus()
}

export const fetchMicrosoftCalendars = () => {
  return RxMeetingsAPI.get('/microsoft/calendar/calendars')
    .checkStatus()
    .retryWithBackoff()
    .map(({ response }) => {
      return response
    })
}

export const updateMicrosoftCalendar = calendar => {
  return RxMeetingsAPI.post('/microsoft/calendar/calendars/choose', calendar).checkStatus()
}

export const fetchDefaultMeetingSettings = () => {
  return RxMeetingsAPI.get('/scheduling/settings')
    .checkStatus()
    .retryWithBackoff()
    .map(({ response }) => response)
}

export const updateDefaultMeetingSettings = (newDefault) => {
  return RxMeetingsAPI.put(
    `/scheduling/settings`,
    {
      allowNewAppointments: newDefault.allowNewAppointments,
      allowMeetingManagement: newDefault.allowMeetingManagement,
      bufferTime: newDefault.bufferTime,
      minimumNoticeTime: newDefault.minimumNoticeTime,
      timezone: newDefault.timezone,
      availability: newDefault.availability.map(slot => {
        return {
          dayOfWeek: slot.dayOfWeek,
          startTimeHour: slot.startTime.hour,
          startTimeMinutes: slot.startTime.minutes,
          endTimeHour: slot.endTime.hour,
          endTimeMinutes: slot.endTime.minutes,
        }
      }),
      meetingTemplate: {
        duration: newDefault.duration,
        name: newDefault.name,
        location: newDefault.location,
        inviteDescription: newDefault.inviteDescription,
      },
    }
  )
}
export const updateMeetingSettings = () => {
  return RxMeetingsAPI.post('/scheduling/settings', { allowMeetingManagement: true }).checkStatus()
}
